import { useRef, useState, type FormEvent, type KeyboardEvent } from "react";
import { Icon } from "../../components/ui/Icon";
import type { HomeProduct } from "../../lib/ccApi";
import { initials } from "../goal/text";
import "../../styles/cc.css";

/** A product's mark on the Command Center: its logo, else its initials (the prototype's `prodIcon`). */
export function Mark({ p }: { p: Pick<HomeProduct, "name" | "logoUrl"> }) {
  return p.logoUrl ? <img className="nwr" src={p.logoUrl} alt="" /> : <i className="nwr">{initials(p.name)}</i>;
}

const grow = (t: HTMLTextAreaElement) => {
  t.style.height = "auto";
  t.style.height = `${Math.min(160, t.scrollHeight)}px`;
};

/** The prototype's box (`.cc-box`): one line that grows, Enter sends, Shift and Enter starts a new line. */
export function AskBox({ placeholder, onSend, busy = false }: { placeholder: string; onSend: (text: string) => void; busy?: boolean }) {
  const [text, setText] = useState("");
  const ref = useRef<HTMLTextAreaElement>(null);
  const send = (e?: FormEvent) => {
    e?.preventDefault();
    const v = text.trim();
    if (!v || busy) return;
    setText("");
    if (ref.current) {
      ref.current.value = "";
      grow(ref.current);
    }
    onSend(v);
  };
  const key = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  };
  return (
    <form className="cc-box" onSubmit={send}>
      <textarea
        ref={ref}
        rows={1}
        placeholder={placeholder}
        aria-label={placeholder}
        enterKeyHint="send"
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          grow(e.target);
        }}
        onKeyDown={key}
      />
      <button className="cc-send" type="submit" aria-label="Send" disabled={busy}>
        <Icon name="send" />
      </button>
    </form>
  );
}
